import React, { useEffect, useState } from "react";
import { useForm, useController, Controller } from "react-hook-form";
import {
  Row,
  Col,
  Label,
  Alert,
  Form,
  FormGroup,
  Input,
  Container,
} from "reactstrap";
import {
  TextFieldHookForm,
  SearchableSelectHookForm,
} from "../../../layout/HookFormInputs";
import {
  checkWhiteSpaces,
  number,
  email,
  userDetails,
} from "../../../../helper";
import {
  getBusinessTypesForDropdown,
  getAllApproversForDropdown,
  addNewSpecialization,
  getSpecializationDetailById,
  updateExistingSpecialization,
  fetchAllSpecialization,
  activeInactivePartStatus
} from "../Actions";
import { useDispatch } from "react-redux";
import Toaster from "../../../common/Toaster";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LoaderCustom from "../../../common/LoaderCustom";
import { Drawer } from "@material-ui/core";
import PopupMsgWrapper from "../../../common/PopupMsgWrapper";

const AddSpecializationList = (props) => {
  const userDetail = userDetails();
  const urlParams = new URLSearchParams(window.location.search);
  // const Id = urlParams.get("Id");
  const Id = props?.open?.id;
  const guid = props?.open?.guid;
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { isSubmitting, isSubmitted, isValid, errors },
  } = useForm({ defaultValues: { IsActive: true }, mode: "onChange" });
  const [showPopup, setShowPopup] = useState(false);
  const handleApproverChange = () => {
    setShowPopup(true);
  };


  const [loading, setLoading] = useState(false); // Loading state
  const [businessTypeList, setbusinessTypeList] = useState([]);
  const [approverList, setapproverList] = useState([]);
  const [isActive, setisActive] = useState(true);
  const [loader, setloader] = useState(false);
  const [SpecializationData, setSpecializationData] = useState(null);

  useEffect(() => {
    getAllBusinessTypes();
    getAllApproverListData();
    if (guid) {
      setLoading(true); // Start loading

      getSpecializationDetailById(guid)
        .then(async (res) => {
          const specializationData = res?.data?.SpecializationById;
          const data = { ...specializationData[0] };
          setSpecializationData(data);
          setValue("SpecializationName", data?.SpecializationName);
          if (data?.BusinessTypeId) {
            setValue("BusinessTypeId", {
              value: data?.BusinessTypeId || "",
              label: data?.BusinessTypeName || "",
            });
          }
          setValue("EmployeeId", {
            value: data?.EmployeeId || "",
            label: data?.EmployeeName,
          });
          setisActive(!!data?.IsActive);
        })
        .catch((error) => {
          // Handle error if needed
        })
        .finally(() => {
          setLoading(false); // Stop loading
        });
    } else {
      setLoading(false); // Stop loading
      reset();
    }
  }, [Id, reset]);
  const closePopUp = () => {
    setShowPopup(false);
    setValue("EmployeeId", {
      value: SpecializationData?.EmployeeId || "",
      label: SpecializationData?.EmployeeName,
    });
  };
  const onPopupConfirm = () => {
    setShowPopup(false);
    // setInitialApprover(watch("EmployeeId")); // Update initial value to new selection
  };
  const getAllBusinessTypes = () => {
    setLoading(true); // Set loading to true during data fetching
    getBusinessTypesForDropdown()
      .then((res) => {
        setbusinessTypeList(res?.Data);
      })
      .catch(() => { })
      .finally(() => setLoading(false)); // Set loading to false after data fetching
  };
  const getAllApproverListData = () => {
    setLoading(true); // Set loading to true during data fetching
    getAllApproversForDropdown()
      .then((res) => {
        setapproverList(res?.Data);
      })
      .catch(() => { })
      .finally(() => setLoading(false)); // Set loading to false after data fetching
  };
  const cancel = () => {
    props.closeDrawer();
    reset();
  };

  const getUsers = async (currentPage, pageSize, sortOrder, fieldName) => {
    try {
      // Set loader to true to indicate data fetching
      setloader(true);
      // Dispatch the action to fetch users
      await dispatch(
        fetchAllSpecialization({
          current_page: currentPage,
          per_page: pageSize,
          sortOrder: sortOrder,
          sortField: fieldName,
        })
      );
      // Reset loader to false after the data is fetched
      setloader(false);
    } catch (error) {
      // Handle errors, e.g., display an error message

      // Reset loader to false in case of an error
      setloader(false);
    }
  };

  const onSubmit = async (data) => {
    setLoading(true); // Set loading to true during submission
    const empId = userDetails();
    const payload = {
      SpecializationName: data?.SpecializationName,
      IsActive: isActive,
      BusinessTypeId: data?.BusinessTypeId?.value,
      EmployeeId: parseInt(data?.EmployeeId?.value),
    };

    if (Id) {
      const payloadUpload = {
        SpecializationName: data?.SpecializationName,
        IsActive: isActive,
        BusinessTypeId: data?.BusinessTypeId?.value,
        EmployeeId: parseInt(data?.EmployeeId?.value),
        Id: parseInt(Id),
      };
      dispatch(
        updateExistingSpecialization(payloadUpload, (res) => {
          // 
          // reset();
          setLoading(false); // Set loading to false regardless of success or failure
          if (res && res?.IsSuccessful) {
            Toaster.success(res?.Data?.Message);
            props.setOpen(false);
            // Call getUsers after updating specialization
            getUsers(1, 10, "ASC"); // Assuming these parameters are applicable
          } else {
            Toaster.error(res?.data?.ErrorMessage || "Form submission failed");
          }
        })
      );
    } else {
      dispatch(
        addNewSpecialization(payload, (res) => {
          reset();
          setLoading(false); // Set loading to false regardless of success or failure //loader
          if (res && res.isSuccessful) {
            Toaster.success(res?.data?.Message);
            props.setOpen(false);
            // window.location.reload();

            // Call getUsers after adding new specialization
            getUsers(1, 10, "ASC"); // Assuming these parameters are applicable
          } else {
            Toaster.error(res?.Data?.Message || "Form submission failed");
          }
        })
      );
    }
  };

  const renderListing = (label) => {
    if (label === "businessTypeListing") {
      return businessTypeList.map((businessTypeListing) => ({
        value: businessTypeListing.Id,
        label: businessTypeListing.BusinessTypeName,
      }));
    }
    if (label === "approverListData") {
      return approverList.map((approverListData) => ({
        value: approverListData.EmployeeId,
        label: approverListData.EmployeeName,
      }));
    }
  };

  if (loader) {
    return (
      <div>
        {" "}
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    ); // Render loading indicator if loading is true
  }
  const title = Id ? "Update Specialization" : "Add New Specialization";
  return (
    <>
      <div className="bg-white hl-common-page">
        <Drawer
          // anchor={props.anchor}
          open={props.open}
          // onClose={(e) => toggleDrawer(e)}
          anchor={"right"}
        >
          <Container>
            <div className={"drawer-wrapper"}>
              <Row className="drawer-heading">
                <Col>
                  <div className={"header-wrapper left"}>
                    <h3>{title}</h3>
                  </div>
                  <div onClick={cancel} className={"close-button right"}></div>
                </Col>
              </Row>
              <div>
                {loading && <LoaderCustom />}
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Row className="part-detail-wrapper pl-3 pr-3 mt-3 flex-column">
                    <Col md="12">
                      <TextFieldHookForm
                        {...register("SpecializationName")}
                        label={`Specialization Name`}
                        name={"SpecializationName"}
                        onChange={(e) =>
                          setValue("SpecializationName", e.target.value)
                        }
                        Controller={Controller}
                        rules={{
                          required: true,
                          validate: { checkWhiteSpaces },
                          maxLength: 50,
                        }}
                        control={control}
                        placeholder={"Enter"}
                        // register={register}
                        // className=""
                        customClassName={"withBorder mb-0"}
                        handleChange={() => { }}
                        errors={errors.SpecializationName}
                        disabled={false}
                        mandatory={true}
                      />
                    </Col>
                    <Col md="12" className="mt-3">
                      <SearchableSelectHookForm
                        {...register("BusinessTypeId")}
                        label={"Type of Business"}
                        name={"BusinessTypeId"}
                        placeholder={"Select"}
                        Controller={Controller}
                        control={control}
                        rules={{ required: true }}
                        // register={register}
                        options={renderListing("businessTypeListing")}
                        mandatory={true}
                        handleChange={() => { }}
                        errors={errors.BusinessTypeId}
                        disabled={false}
                      />
                    </Col>
                    <Col md="12" className="mt-2">
                      <SearchableSelectHookForm
                        {...register("EmployeeId")}
                        label={"Approver"}
                        name={"EmployeeId"}
                        placeholder={"Select"}
                        Controller={Controller}
                        control={control}
                        rules={{ required: true }}
                        // register={register}
                        options={renderListing("approverListData")}
                        mandatory={true}
                        // handleChange={() => { }}
                        handleChange={handleApproverChange}
                        errors={errors.EmployeeId}
                        disabled={false}
                      />
                    </Col>

                    <Col md="12" className="mt-3 hl-switch-btn">
                      <div>
                        <Label className="mb-0">
                          Status<span className="asterisk-required">*</span>
                        </Label>
                        <FormGroup switch>
                          <Input
                            type="switch"
                            checked={isActive}
                            size="lg"
                            onClick={() => {
                              setisActive(!isActive);
                            }}
                          />
                        </FormGroup>
                      </div>
                    </Col>
                    <Col md="12" className="mt-3 justify-content-end d-flex">
                      <div className="text-right mt-2 pt-1">
                        <button
                          type={"button"}
                          className="reset mr15 cancel-btn"
                          onClick={cancel}
                        >
                          <div className={"cancel-icon"}></div>
                          {"Cancel"}
                        </button>
                        <button
                          type="submit"
                          className="submit-button save-btn"
                        >
                          <div className="save-icon"></div> {Id ? "Update" : "Save"}
                        </button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </Container>
        </Drawer>
        <div>
          {showPopup && props?.requestIdSpecialzation && (
            <PopupMsgWrapper
              isOpen={showPopup}
              closePopUp={closePopUp}
              confirmPopup={onPopupConfirm}
              message={<>
                If the approver for the specialization is changed, all pending supplier repository requests will be reassigned to the new approver. Please confirm if you would like us to proceed with this change?
              </>}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AddSpecializationList;
